import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqHeroComponent } from '../../components/faq/faq-hero/faq-hero.component';
import { FaqAccordionComponent } from '../../components/faq/faq-accordion/faq-accordion.component';
import { ApplyBannerComponent } from '../../components/common/apply-banner/apply-banner.component';
import { CTABannerComponent } from '../../components/common/cta-banner/cta-banner.component';
import { FloatingButtonsComponent } from '../../components/common/floating-buttons/floating-buttons.component';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-preguntas-frecuentes',
  standalone: true,
  imports: [
    CommonModule,
    FaqHeroComponent,
    FaqAccordionComponent,
    ApplyBannerComponent,
    CTABannerComponent,
    FloatingButtonsComponent
  ],
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: ['./preguntas-frecuentes.component.scss']
})
export class PreguntasFrecuentesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('faqPage', { static: false }) faqPage?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track page view
    this.analyticsService.trackPageView('Preguntas Frecuentes', '/preguntas-frecuentes');
  }

  ngAfterViewInit() {
    // Registrar la página completa para tracking de analytics
    if (this.faqPage?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.faqPage.nativeElement,
        'FAQ Page',
        'faq-page-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
